<template>
    <!-- 上传附件 -->
    <div class="wk-input-uploader wk-input-box wk-input-uploader-box">
        <span class="input-left-label">{{label}}</span>
        <div class="posi-relative">
            <input-base />
            <!-- 上传按钮 -->
            <div class="posi-absolute-0">           
                <van-uploader :after-read="onRead">
                    <van-icon name="photograph" />
                </van-uploader>
                <p class="posi-absolute-0 tip-txt  flex-jf-center"> 
                    <img src="../../assets/img/sctp_jt.png">
                    <span>{{uploaderTxt}}</span>
                </p>
                <p class="posi-absolute right-txt"> {{linkTxt}} </p>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label', 'upName','upSuccTip','uploaderTxt','linkTxt',],
        methods:{
            onRead(file){
                let fileObj = {
                    files:file.file,
                    upName:this.upName,
                    upSuccTip:this.upSuccTip
                }
                this.$emit('upBack',fileObj)
            }
        }
    }
</script>
<style lang="less" scoped>
    .wk-input-uploader{
        margin:.9rem 0;
        >div.posi-relative{
            >div.posi-absolute-0{
                line-height: 2.1rem;
                padding:0 .5rem;
                border:.05rem solid #d1d1d1;
                color:#FBFBFB;
                background: #FBFBFB;             
                z-index: 2;
                // 上传附件的的提示文字
                >p.tip-txt{ 
                    cursor: pointer;
                    color:#003399;
                    z-index: 1;
                    img{
                        width:0.9rem;
                        height:0.9rem;
                        margin:.6rem .3rem 0 0;
                    }
                }
                // 右边下载文字提示
                >p.right-txt{
                    top:0;
                    left:100%;
                    width: 7rem;
                    padding-left:.5rem;
                    font-size:0.8rem;
                    text-decoration: underline;
                    color:#003399;
                }
            }
        }        
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputUploaderBlock.vue